import m from "./ghl-ui.es1177.js";
import a from "./ghl-ui.es1157.js";
const c = (o) => {
  const {
    boxShadow2: r,
    popoverColor: t,
    textColor2: e,
    borderRadius: i,
    fontSize: n,
    dividerColor: s
  } = o;
  return Object.assign(Object.assign({}, m), {
    fontSize: n,
    borderRadius: i,
    color: t,
    dividerColor: s,
    textColor: e,
    boxShadow: r
  });
}, p = {
  name: "Popover",
  common: a,
  self: c
}, b = p;
export {
  b as default,
  c as self
};
